import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(APIS.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStatesByCountryId, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCitiesByStateId, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}

export function* handleFetchPaymentMethods({ payload }) {
  try {
    const res = yield call(APIS.fetchPaymentMethods, payload);
    const { data } = res;
    yield put(actions.fetchPaymentMethodsSuccess(data));
  } catch (err) {
    yield put(actions.fetchPaymentMethodsFailure(err?.response?.data));
  }
}

export function* handleAddCompany({ payload }) {
  try {
    const res = yield call(APIS.addCompany, payload.data);
    const { data } = res;
    yield put(actions.addCompanySuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.addCompanyFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.addCompanyFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* companyAddSaga() {
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(actions.addCompany.type, handleAddCompany);
  yield takeLatest(actions.fetchPaymentMethods.type, handleFetchPaymentMethods);
}
